import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=74dc0ad2&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dc0ad2')) {
      api.createRecord('74dc0ad2', component.options)
    } else {
      api.reload('74dc0ad2', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=74dc0ad2&", function () {
      api.rerender('74dc0ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20obWn0Xya0Tn/JS/cancellationPolicy.vue"
export default component.exports